import React from "react";
import { CloseIcon } from "../../Icons";

/**
 * Fixed-position close control for application form overlays.
 * Uses `fixed` so it stays clickable above scrollable form content.
 */
const CloseButton = ({ onClose, className = "" }) => {
  if (typeof onClose !== "function") return null;

  return (
    <div className={`fixed top-4 right-4 z-[70] ${className}`}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }}
        className="rounded-full bg-white p-2 shadow-lg transition-colors duration-200 hover:bg-gray-100"
        aria-label="Close form"
      >
        <CloseIcon size={20} className="text-gray-600" />
      </button>
    </div>
  );
};

export default CloseButton;
